const AppLinks = {
  WindowsPhone: "https://play.google.com/store/apps/details?id=com.appokart.scoffco",
  Android: "https://play.google.com/store/apps/details?id=com.appokart.scoffco",
  iOS: "https://apps.apple.com/in/app/scoffco/id6778426151",
  unknown: "https://scoffco.com",
};

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("apkt-app-alert-popup");
  const closeBtn = document.getElementById("apkt-alert-popup-close");
  const alertLink = document.getElementById("app-alert-click-here");
  const isMobile = window.matchMedia("(pointer:coarse)").matches;
  const systemType = getMobileOperatingSystem();

  closeBtn?.addEventListener("click", () => {
    hideModal();
  });

  window.addEventListener("click", (event) => {
    if (event.target === modal) {
      hideModal();
    }
  });

  window.addEventListener("scroll", hideModal);

  if (isMobile) {
    showModal();
  }

  const appUrl = AppLinks[systemType];
  if (alertLink) {
    alertLink.href = appUrl;
  }

  function hideModal() {
    if (modal) {
      modal.style.display = "none";
    }
  }

  function showModal() {
    if (modal) {
      modal.style.display = "block";
    }
  }

  function getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
      return "WindowsPhone";
    }
    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "unknown";
  }
});
